<template>
  <div
    id="passwordField" 
    @click="onClickPasswordField"
  >
    <v-text-field
      v-model="password"
      required
      :type="type"
      counter="256"
      maxlength="256"
      :prepend-icon="prepend_icon"
    />
  </div>
</template>

<script>

const type_pass = 'password';
const type_text = 'text';

const prepend_icon_eye_off = 'mdi-eye-off';
const prepend_icon_eye_on = 'mdi-eye';

export default {
  name: 'App',

  components: {
  },
  data: () => ({
    password : '',
    type : type_pass,
    prepend_icon : prepend_icon_eye_off,
  }),
  methods: {
    onClickPasswordField(event){
      //v-icon notranslate mdi mdi-eye-off theme--light
      if(event.target && event.target.className.search(/mdi-eye-off/g) > 0){
        // パスワード文字列が見えないアイコンがおされたのでパスワードを表示
        this.prepend_icon = prepend_icon_eye_on;
        this.type = type_text;
      } else if(event.target && event.target.className.search(/mdi-eye/g) > 0){
        // パスワード文字列が見えるアイコンがおされたのでパスワードを非表示
        this.prepend_icon = prepend_icon_eye_off;
        this.type = type_pass;
      }
    },
    getPassword(){
      return this.password;
    },
  },
};
</script>

<style>
.mdi-eye {cursor:pointer;}
.mdi-eye-off {cursor:pointer;}
</style>